import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon width="16" height="16" viewBox="0 0 16 16" {...props}>
      <title>{props.title || 'Chevron-Right'}</title>
      <g fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9737 7.80015C11.0713 7.90382 11.0713 7.99885 10.9737 8.08524L6.36398 13.0096C6.26642 13.1133 6.16886 13.1133 6.0713 13.0096L4.65667 11.5064C4.55911 11.4027 4.55911 11.2991 4.65667 11.1954L7.72984 7.92973L4.65667 4.68999C4.55911 4.58632 4.55911 4.48265 4.65667 4.37898L6.0713 2.87574C6.13634 2.84118 6.18512 2.8239 6.21764 2.8239C6.26642 2.8239 6.3152 2.84118 6.36398 2.87574L10.9737 7.80015Z"
          fill="#4C4C4C"
        />
      </g>
    </Icon>
  )
}
